import React, { useCallback, useEffect, useState } from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { InlineAlert, styled } from '@driftt/dds'
import { CircleLoader } from '@driftt/tide-core'
import { setAccessToken } from '@driftt/web-auth'

import * as UserActions from 'modules/user/actions'

import useAcceptThirdPartyInvite from './useAcceptThirdPartyInvite.hook'

const InviteErrorAlert = styled(InlineAlert, {
  '& p': {
    margin: '0px!important',
    textAlign: 'unset!important',
  },
})

const ThirdPartyLandingPage = ({ history, actions }) => {
  const [loading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const { acceptGoogleInvitation, acceptMicrosoftInvitation } =
    useAcceptThirdPartyInvite()

  const handleUpdateUserValues = useCallback(
    ({ name, avatarUrl, workspaceRoles, id }) => {
      actions.setName(name)
      actions.setAvatarUrl(avatarUrl)
      actions.setUserRoles(workspaceRoles)
      actions.setUserId(id)
    },
    [actions]
  )

  const handleSuccess = useCallback(
    ({ data }) => {
      const { accessToken, user } = data
      handleUpdateUserValues(user)
      setAccessToken({ token: accessToken })
      actions.setHasSocialInvite(true) // reset redux value
      history.push('/invite/profile')
    },
    [handleUpdateUserValues, actions, history]
  )

  const handleError = useCallback(
    (err) => setIsError(() => true, console.error(err)),
    []
  )

  const handleGoogle = useCallback(
    async (token) =>
      setIsError(
        () => false,
        setLoading(
          () => true,
          acceptGoogleInvitation(token)
            .then((res) => setLoading(() => false, handleSuccess(res)))
            .catch((error) => setLoading(() => false, handleError(error)))
        )
      ),
    [acceptGoogleInvitation, handleSuccess, handleError]
  )

  const handleMicrosoft = useCallback(
    async (token) =>
      setIsError(
        () => false,
        setLoading(
          () => true,
          acceptMicrosoftInvitation(token)
            .then((res) => setLoading(() => false, handleSuccess(res)))
            .catch((error) => setLoading(() => false, handleError(error)))
        )
      ),
    [acceptMicrosoftInvitation, handleSuccess, handleError]
  )

  useEffect(() => {
    const { pathname, search, href } = window.location
    const searchParams = new URL(href).searchParams
    const code = searchParams.get('code')

    search && pathname.includes('google')
      ? handleGoogle(code)
      : handleMicrosoft(code)
  }, [handleGoogle, handleMicrosoft])

  return loading ? (
    <CircleLoader size="large" />
  ) : (
    isError && (
      <InviteErrorAlert
        title="Uh oh!"
        description="We ran into an issue creating your account. Please retry accepting your invitation."
        variant="error"
      />
    )
  )
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      setName: UserActions.setName,
      setFlow: UserActions.setFlow,
      setAvatarUrl: UserActions.setAvatarUrl,
      setHasSocialInvite: UserActions.setHasSocialInvite,
      setUserRoles: UserActions.setUserRoles,
      setUserId: UserActions.setUserId,
    },
    dispatch
  ),
})

export default connect(null, mapDispatchToProps)(ThirdPartyLandingPage)
